@if ($cotixUrl()) {
	<div class="flex self-end bg-canvas p-4">
		<uikit-icon
			(click)="close()"
			name="close"
			size="md"
			fill="on-background-alt"
			class="flex h-5 w-5 cursor-pointer rounded bg-surface"
		></uikit-icon>
	</div>
	<iframe
		[src]="$cotixUrl()"
		sandbox="allow-scripts allow-same-origin allow-forms"
		(load)="loaded()"
		loading="lazy"
	></iframe>
}
@if (!$iframeLoaded()) {
	<div class="flex h-full w-full items-center justify-center">
		<cba-loader-spinner-ay class="h-12 w-12"></cba-loader-spinner-ay>
	</div>
}
